import CaptchaButton from './CaptchaButton';


export default CaptchaButton;
